// extracted by mini-css-extract-plugin
export default {"emphasized":"CellValue_emphasized__2iRFf"};